module.exports = __webpack_public_path__ + "img/pr-4.88c3319b.png";